exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nav-popover {\n  font-weight: 600;\n  color: var(--color-mineshaft);\n}\n.nav-popover .small {\n  color: var(--color-mineshaft);\n}\n.nav-popover:hover,\n.nav-popover:active,\n.nav-popover:focus {\n  color: var(--color-mineshaft);\n  text-decoration: none;\n}\n", ""]);

